import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/hub.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/koltsegvetes.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/programok.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/szolgaltatok.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/teendoim.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/ultetesi-rend.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/uzenetek.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/vendeglista.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/organizer_landing/weboldal.webp");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/_dot.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/budget_icons/coin-stack.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/grid.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/heart.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/layers.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/list.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/loader.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/message-circle.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/users.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/wifi.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/common/buttons/button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/link_with_params/link_with_params.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/organizer_landing/organizer_landing.module.css");
